import { Autocomplete as UIAutocomplete } from "@webmotors/eleanor-ui";

export interface AutocompleteDSOptionProps {
  text: string;
  value: string;
}

export interface AutocompleteDSGroupedOptionProps {
  label: string;
  itens: AutocompleteDSOptionProps[];
}

export type OptionsType =
  | AutocompleteDSOptionProps[]
  | AutocompleteDSGroupedOptionProps[];

type AutocompleteSizeProps = "small" | "medium" | "large";

export interface AutocompleteDSComponentProps {
  options: OptionsType;
  label?: string;
  placeholder: string;
  value?: string;
  noOptionsText?: string;
  clearable?: boolean;
  minCharsToFilter?: number;
  onInputChange?: (option: AutocompleteDSOptionProps) => void;
  onClick?: (option: AutocompleteDSOptionProps) => void;
  disabled?: boolean;
  hasError?: boolean;
  size?: AutocompleteSizeProps;
  auxiliarText?: string;
  className?: string;
  withoutIcon?: boolean;
  iconRight?: JSX.Element;
  iconSubItem?: JSX.Element;
}

export const AutocompleteDS = ({
  options,
  label,
  placeholder,
  value,
  noOptionsText,
  clearable,
  minCharsToFilter,
  onInputChange,
  onClick,
  disabled,
  hasError,
  size = "small",
  auxiliarText,
  className,
  withoutIcon,
  iconRight,
  iconSubItem,
  ...props
}: AutocompleteDSComponentProps) => {
  return (
    <UIAutocomplete
      options={options}
      label={label}
      placeholder={placeholder}
      value={value}
      noOptionsText={noOptionsText}
      clearable={clearable}
      minCharsToFilter={minCharsToFilter}
      onInputChange={onInputChange}
      onClick={onClick}
      disabled={disabled}
      hasError={hasError}
      size={size}
      auxiliarText={auxiliarText}
      className={className}
      withoutIcon={withoutIcon}
      iconRight={iconRight}
      iconSubItem={iconSubItem}
      {...props}
    />
  );
};
